import React, { useState, useEffect } from 'react';
import IslandSelector from '../componentes/PuntoVenta/IslandSelector';
import ClientPicker from '../componentes/invoice/ClientPicker';
import InvoiceInfoInput from '../componentes/invoice/InvoiceInfoInput';
import { BOLETA, calcularTotales, FACTURA, IGV, EFECTIVO, PAGO_CREDITO, IVAP, CREDITO, CONTADO, decimalAdjust, VALE } from '../Global';
import DocTypeSelector from '../componentes/invoice/DocTypeSelector';
import { defaultPostHeaders } from '../helpers/wrappers';
import { notificarError, notificarMsg } from '../componentes/Almacenes/AlmacenNotify';
import _ from 'lodash';
import $ from 'jquery';
import { getPayloadFromPreVenta } from '../helpers/utils';
import {
    FindPrecioEspecial,
    FindPrecioFamiliar,
    FindPrecioMenor,
    FindPrecioPorMayor,
    GetPrecioCosto,
    getPrecioPorMayor
} from '../componentes/Preventas/PreciosPreventa';
import { calcTotal } from '../Global';
import calcularVenta from '../helpers/calcularVenta';
import GrifosPagos from './GrifosPagos';
import DetallesProductoGrifos from '../componentes/Preventas/DetallesProductoGrifos';
import PagosUI from './RegistroVentas/PagosUI';
import '../componentes/styles/Grifos.css';
const Grifos = () => {
    const [isMobile, setIsMobile] = useState(false);
    const [payload, setPayload] = useState({ detalles: [] });
    const [totales, setTotales] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [addedFirstItem, setAddedFirstItem] = useState(false);
    const [pagos, setPagos] = useState([]);
    const [totalPagado, setTotalPagado] = useState(0);
    const [vuelto, setVuelto] = useState(0);
    // TODO: Estados para modal de validación de pagos (futura implementación)
    // const [showModalValidacion, setShowModalValidacion] = useState(false);
    // const [modalValidacionTipoPago, setModalValidacionTipoPago] = useState(null);
    
    // TODO: Estados para deshabilitar botones de pago (futura implementación)
    // const [disableCredit, setDisableCredit] = useState(false);
    // const [disableAll, setDisableAll] = useState(false);
    
    const [shouldRemovePayments, setShouldRemovePayments] = useState(false);
    // TODO: Estado confEmpresa sin usar (revisar si es necesario)
    // const [confEmpresa, setConfEmpresa] = useState(false);
    /*bloqueo de panel cliente en funcion al producto */
    const [panelBloqueado, setPanelBloqueado] = useState(false);
    const [panelPagosBloqueado, setPanelPagosBloqueado] = useState(true);
    const queryParams = new URLSearchParams(window.location.search);

    // Cargar configuración del servidor al montar el componente
    useEffect(() => {
        const fetchConfig = async () => {
            try {
                const response = await fetch("/api/pre-invoice/config");
                if (!response.ok) {
                    throw new Error();
                }
                const config = await response.json();
                setPayload(prev => ({
                    ...prev,
                    conf: config
                }));
            } catch (e) {
                console.error("Error al cargar configuración:", e);
                notificarError("No se pudo cargar la configuración");
            }
        };
        fetchConfig();
    }, []);

    /**
     * Valida si el cliente seleccionado es válido
     */
    const isClientValid = () => {
        if (payload.IdTipoDocumentoSunat === VALE) {
            return true;
        }
        if (!payload._client || payload._client.RazonSocial?.trim() === "VARIOS") {
            return false;
        }
        
        return payload._client.NroTipoDocumento && 
            (payload._client.NroTipoDocumento.length === 8 || 
                payload._client.NroTipoDocumento.length === 11) && 
            payload._client.NroTipoDocumento !== "99999999";
    };

    /**
     * Valida que los pagos sean correctos y suficientes
     */
    const isPaymentValid = () => {
        if (shouldRemovePayments) {
            notificarError("El orden de los medios de pago seleccionados no son válidos. Verifique si todos son necesarios e inténtelo otra vez.");
            return false;
        }

        if (totalPagado < decimalAdjust('floor', totales.totalMonto, -2)) {
            notificarError("El monto pagado es menor al total");
            return false;
        }

        return true;
    };

    // ===== FIN FUNCIONES DE VALIDACIÓN =====

    // Efecto 1: Crear preventa cuando se agrega el primer producto
    useEffect(() => {
        if (addedFirstItem) {
            onAddPreInvoice();
        }
    }, [addedFirstItem]);

    // TODO: Efecto 2 - Validar habilitación de método crédito (futura implementación)
    // useEffect(() => {
    //     const clienteVarios = payload._client?.NroTipoDocumento === "99999999";
    //     const hasCreditPayment = pagos.some(p => p.IdTipoPago === PAGO_CREDITO);
    //     setDisableCredit(clienteVarios || hasCreditPayment);
    //     if (pagos.length === 0) {
    //         setDisableAll(false);
    //         return;
    //     }
    //     const lastPaymentIsContado = pagos[pagos.length - 1].IdTipoPago === EFECTIVO;
    //     setDisableAll(lastPaymentIsContado);
    // }, [pagos.length]);

    // TODO: Efecto 3 - Validar deshabilitación basada en monto pagado (futura implementación)
    // useEffect(() => {
    //     const lastPaymentIsContado = pagos.length > 0 && pagos[pagos.length - 1].IdTipoPago === EFECTIVO;
    //     if (lastPaymentIsContado) {
    //         setDisableAll(true);
    //         return;
    //     }
    //     const isCompleted = totales.totalMonto - totalPagado <= 0;
    //     setDisableAll(isCompleted);
    // }, [totalPagado]);

    // Efecto 4: Validar que el orden de pagos sea correcto
    useEffect(() => {
        if (!Array.isArray(pagos) || pagos.length === 0) {
            setShouldRemovePayments(false);
            return;
        }

        let fromLeft = false;
        let fromRight = false;

        let restante = totales.totalMonto;

        for (let i = 0; i < pagos.length; i++) {
            const pago = pagos[i];
            restante = restante - pago.Monto;

            if (restante < 0 && pagos.length - 1 !== i) {
                fromLeft = true;
                break;
            }
        }

        restante = totales.totalMonto;

        for (let i = pagos.length - 1; i >= 0; i--) {
            const pago = pagos[i];
            restante = restante - pago.Monto;

            if (restante < 0 && i > 0) {
                fromRight = true;
                break;
            }
        }

        setShouldRemovePayments(fromLeft || fromRight);
    }, [totalPagado]);

    // Efecto 5: Inicializar documento por defecto desde config del servidor
    useEffect(() => {
        if (payload.conf && 'defaultSellDocument' in payload.conf) {
            const defaultSellDocument = payload.conf.defaultSellDocument;

            const _docs = {
                [FACTURA]: { key: FACTURA, name: "Factura" },
                [BOLETA]: { key: BOLETA, name: "Boleta" },
                [VALE]: { key: VALE, name: "Vale" }
            };

            setPayload(prev => ({
                ...prev,
                _docType: _docs[defaultSellDocument],
                IdTipoDocumentoSunat: defaultSellDocument
            }));
        }
    }, [payload.conf?.defaultSellDocument]);

    // TODO: Funciones de gestión de pagos (futura implementación de modal de validación)
    // Nota: La lógica de pagos está actualmente en el componente hijo GrifosPagos
    // Estas funciones se mantienen para referencia en caso de que se necesite validación adicional en el padre
    
    // const checkPerm = async (perm, tipoPago) => {
    //     try {
    //         const req = await fetch(`/api/usuarios/${perm}/validar`);
    //         if (!req.ok) throw new Error();
    //         const data = await req.json();
    //         setModalValidacionTipoPago(tipoPago);
    //         setShowModalValidacion(data.codigoConfirmacion);
    //     } catch (e) {
    //         handleTipoPago(tipoPago)();
    //         setShowModalValidacion(false);
    //     }
    // };

    // const handleTipoPago = (IdTipoPago) => {
    //     if (IdTipoPago === PAGO_CREDITO) {
    //         return () => checkPerm('vender-a-credito', PAGO_CREDITO);
    //     }
    //     return () => addDetallePago(IdTipoPago);
    // };

    // const addDetallePago = (IdTipoPago) => {
    //     const remaining = totales.totalMonto - totalPagado;
    //     const newPago = {
    //         IdTipoPago,
    //         Monto: decimalAdjust('floor', remaining, -2),
    //         Referencia: '',
    //         FechaPago: new Date().toISOString().split('T')[0]
    //     };
    //     const newPagos = [...pagos, newPago];
    //     setPagos(newPagos);
    //     const newTotalPagado = newPagos.reduce((total, pago) => total + pago.Monto, 0);
    //     setTotalPagado(newTotalPagado);
    //     setVuelto(newTotalPagado - totales.totalMonto);
    // };

    // const updateMontoPago = async (index, monto) => {
    //     const newPagos = [...pagos];
    //     newPagos[index].Monto = parseFloat(monto) || 0;
    //     setPagos(newPagos);
    //     const totalPagado = newPagos.reduce((total, pago) => total + pago.Monto, 0);
    //     setTotalPagado(totalPagado);
    //     setVuelto(totalPagado - totales.totalMonto);
    // };

    // const updateReferenciaPago = (index, referencia) => {
    //     const newPagos = [...pagos];
    //     newPagos[index].Referencia = referencia;
    //     setPagos(newPagos);
    // };

    // const removePago = (index) => {
    //     const newPagos = [...pagos];
    //     newPagos.splice(index, 1);
    //     setPagos(newPagos);
    //     const totalPagado = newPagos.reduce((total, pago) => total + pago.Monto, 0);
    //     setTotalPagado(totalPagado);
    //     setVuelto(totalPagado - totales.totalMonto);
    // };

    // const handlePagar = async () => {
    //     if (!isPaymentValid()) return;
    //     setIsLoading(true);
    //     try {
    //         const ventaCalculada = await calcularVenta({
    //             Descuento: 0,
    //             TasaIGV: IGV,
    //             TasaICBPER: 0.3,
    //             TasaIVAP: IVAP,
    //             Items: payload.detalles.map(detalle => ({
    //                 ValorUnitario: detalle.ValorUnitario,
    //                 Cantidad: detalle.Cantidad,
    //                 Descuento: detalle.Descuento,
    //                 Tributos: JSON.parse(detalle.Tributos),
    //                 TasaISC: detalle.TasaIsc,
    //                 IdStock: detalle.IdStock,
    //                 PrecioReferencial: detalle.PrecioReferencial,
    //                 IdAfectacionIgv: detalle.IdAfectacionIgv,
    //                 IdPresentacion: detalle.IdPresentacion,
    //                 TipoCambio: detalle.TipoCambio,
    //                 Gratuito: detalle.Gratuito,
    //                 PrecioVenta: detalle.PrecioVenta,
    //             }))
    //         });
    //         await registrarVenta(ventaCalculada);
    //         notificarMsg("Venta registrada correctamente");
    //     } catch (e) {
    //         console.error(e);
    //         notificarError("No se pudo registrar la venta");
    //     } finally {
    //         setIsLoading(false);
    //     }
    // };

    const registrarVenta = async (ventaCalculada) => {
        const totales = calcularTotales(payload.detalles);
        const pagosInfo = pagos?.map(p => p.extra_metadata).filter(e => !!e);

        const response = await fetch("/api/ventas/new", {
            method: "POST",
            headers: defaultPostHeaders(),
            body: JSON.stringify({
                IdCliente: payload._client?.IdCliente,
                IdTipoOperacion: payload.IdPreventa,
                TipoTabla: "Preventas",
                Estado: "GENERADO",
                IdModalidadPago: pagos.some(({IdTipoPago}) => IdTipoPago === PAGO_CREDITO) ? CREDITO : CONTADO,
                IdTipoComprobante: payload.IdTipoDocumentoSunat,
                IdMoneda: 1,
                TipoCambio: 1,
                TasaIGV: IGV,
                TasaICBPER: 0.3,
                DescuentoTotal: 0,
                Gravadas: totales.gravados,
                Exoneradas: totales.exonerados,
                Inafectas: totales.inafectos,
                ICBPER: totales.icbper,
                Exportacion: 0.0,
                Total: totales.total,
                Vuelto: vuelto,
                Observacion: payload.Observaciones || "",
                IGV: totales.gravados * IGV,
                ISC: ventaCalculada.ISC,
                Gratuitas: totales.gratuitos,
                PorcentajeDescuento: ventaCalculada.PorcentajeDescuento,
                IVAP: ventaCalculada.IVAP,
                TasaIVAP: ventaCalculada.TasaIVAP,
                TasaISC: ventaCalculada.ISC,
                descuento: ventaCalculada.Descuento,
                Redondeo: totales.redondeo,
                pagosInfo: JSON.stringify(pagosInfo),
                guiaRemision: payload.GuiaRemision,
                ordenCompra: payload.OrdenCompra
            })
        });

        if (!response.ok) {
            throw new Error();
        }

        const [[table_data], [header]] = await response.json();
        let error = false;
        if (header._estado) {
            error = header._estado;
        } else if (header._estadoRegistroVentas !== true) {
            error = header._estadoRegistroVentas;
        }

        if (error) {
            throw new Error(error);
        }

        const [{IdRegistroVenta}] = table_data;

        // Registrar pagos
        await fetch("/api/pagos/new", {
            method: "POST",
            headers: defaultPostHeaders(),
            body: JSON.stringify({
                DetallesPagos: pagos.map(pago => [
                    IdRegistroVenta,
                    pago.IdTipoPago,
                    pago.Monto,
                    "PAGADO",
                    pago.Referencia,
                    pago.FechaPago,
                    true,
                    0
                ])
            })
        });

        // Registrar detalles de venta
        await fetch("/api/ventas/detalles/new", {
            method: "POST",
            headers: defaultPostHeaders(),
            body: JSON.stringify({
                Items: ventaCalculada.Items.map(detalle => [
                    IdRegistroVenta,
                    detalle.IdStock,
                    detalle.Cantidad,
                    detalle.PrecioReferencial,
                    detalle.PrecioVenta,
                    detalle.IdAfectacionIgv,
                    detalle.IdPresentacion,
                    detalle.Total,
                    detalle.Descuento,
                    detalle.TipoCambio,
                    detalle.ISC,
                    detalle.IGV,
                    detalle.ICBPER,
                    detalle.IVAP,
                    detalle.TasaISC,
                    detalle.ValorUnitario,
                    detalle.DescuentoSI,
                    detalle.Gratuito
                ])
            })
        });

        // Enviar a SUNAT
        await fetch(`/api/configFactElectronica/ce/${IdRegistroVenta}`);
    };

    const showDecrementPriceError = _.debounce(() => {
        const items = [...payload.detalles];

        for (let i = 0; i < items.length; i++) {
            const item = items[i];

            if ('priceIsOk' in item && !item.priceIsOk) {
                notificarError(`Hay un error! El precio no puede ser inferior al precio de venta original. Posición ${i + 1}`)
                break;
            }
        }
    }, 500);

    const updateState = (items, additional = {}) => {
        const totales = calcularTotales(items);
        
        setPayload(prev => ({
            ...prev,
            detalles: items,
            _totales: { ...totales }
        }));
        setTotales({
            Gravado: totales.gravados,
            Inafecto: totales.inafectos,
            Exonerado: totales.exonerados,
            IGVPreventa: totales.gravados * IGV,
            Gratuitas: totales.gratuitos,
            totalMonto: totales.total,
            ICBPERPreventa: totales.icbper,
            redondeo: totales.redondeo,
        });

        if (items.length === 1 && !addedFirstItem) {
            setAddedFirstItem(true);
        }
    };

    const onAddPreInvoice = async () => {
        let tmpPayload = getPayloadFromPreVenta(payload);

        $(".trDetallePreventa").removeClass("alert alert-danger");

        try {
            setIsLoading(true);
            const response = await fetch("/api/pre-invoice/add/v2", {
                method: "POST",
                headers: { ...defaultPostHeaders() },
                body: JSON.stringify(tmpPayload)
            });

            if (!response.ok) {
                throw new Error();
            }

            const data = await response.json();

            const {IdPreventa} = data;
            getPreventa(IdPreventa);
            
            notificarMsg("Venta agregada correctamente");
        } catch (e) {
            console.error(e);
            if (e.message.includes("stock")) {
                $("#BtnReloadProds").click();
            }
            notificarError(e.message || "No se pudo agregar la venta");
        } finally {
            setIsLoading(false);
        }
    };

    const onSelectItem = (item, descuento = 0, cantidad = 1) => {
        $("#InputBuscarProd").focus();
        let items = [...payload.detalles];
        const i = items.indexOfObject(item, 'IdPresentacion');

        if (i !== -1) {
            items[i].Cantidad = items[i].Cantidad + cantidad;
            FindPrecioPorMayor([], items[i]);
            items[i].Total = calcTotal(items[i]);
        } else {
            FindPrecioPorMayor([], item);

            const detail = {
                ...item,
                Cantidad: cantidad,
                Descuento: 0,
                PrecioVenta: item.PrecioVenta,
                PrecioEspecial: FindPrecioEspecial([], item),
                PrecioFamiliar: FindPrecioFamiliar([], item),
                PrecioCosto: GetPrecioCosto([], item),
                PrecioMenor: FindPrecioMenor([], item),
                precioMayor: getPrecioPorMayor([], item),
                checked: 0,
                oldPrecios: [item.PrecioVenta],
                initialAfectGrat: item.IdAfectacionIgv,
                oldCants: [1],
                NombreProducto: item.descripcion,
                Tributos: item.Tributos
            };

            detail.Total = calcTotal(detail);
            items.push(detail);
        }
        setPanelBloqueado(true);
        setTimeout(() => {
            setPanelPagosBloqueado(false);
        }, 1500)
        updateState(items);
    };

    const onChangeCantidad = (e, item) => {
        const items = [...payload.detalles];
        const i = items.indexOfObject(item, 'IdPresentacion');
        const val = e.target.value;
        items[i].Cantidad = items[i].IdUnidad === 58 || items[i].IdUnidad === 59 ? parseInt(val) : val;
        FindPrecioPorMayor([], items[i]);
        items[i].Total = calcTotal(items[i]);
        updateState(items);
    };

    const onPriceChange = (e, item) => {
        const btnGenerar = document.querySelector('button.generar__boton.btn.btn-success.boton-generar-resp.letra-total');

        if (!payload.conf?.canUpdatePrice && payload.conf?.canIncrementProductPrice) {
            const items = [...payload.detalles];
            const i = items.indexOfObject(item, 'IdPresentacion');
            const nuevoPrecio = e.target.value;

            items[i].priceIsOk = +nuevoPrecio >= +items[i].precio;

            if (!items[i].priceIsOk) {
                showDecrementPriceError();
            }
        }

        const items = [...payload.detalles];

        btnGenerar.removeAttribute("disabled");

        for (let item of items) {
            if ('priceIsOk' in item && !item.priceIsOk) {
                btnGenerar.setAttribute("disabled", "true");
                break;
            }
        }

        const val = e.target.value;
        const i = items.indexOfObject(item, 'IdPresentacion');
        items[i].oldPrecios.push(items[i].PrecioVenta);
        items[i].PrecioVenta = val;
        items[i].Total = calcTotal(items[i]);
        updateState(items);
    };

    const onAddQuantity = (item) => {
        const items = [...payload.detalles];
        const i = items.indexOfObject(item, 'IdPresentacion');
        items[i].Cantidad++;
        items[i].oldCants.push(items[i].Cantidad);
        FindPrecioPorMayor([], items[i]);
        items[i].Total = calcTotal(items[i]);
        updateState(items);
    };

    const onSubstractQuantity = (item) => {
        const items = [...payload.detalles];
        const i = items.indexOfObject(item, 'IdPresentacion');
        items[i].Cantidad--;

        if (items[i].Cantidad <= 0) {
            items[i].Total = 0;
        } else {
            items[i].oldCants.push(items[i].Cantidad);
            FindPrecioPorMayor([], items[i]);
            items[i].Total = calcTotal(items[i]);
        }

        updateState(items);
    };

    const onDeleteItem = (item) => {
        let items = [...payload.detalles];
        items.splice(items.indexOfObject(item, 'IdPresentacion'), 1);
        updateState(items);
    };

    const onChangeTotal = (e, item) => {
        const items = [...payload.detalles];
        const i = items.indexOfObject(item, 'IdPresentacion');
        const val = e.target.value;

        items[i].Cantidad = val / items[i].PrecioVenta;
        items[i].Total = val;
        updateState(items);
    };

    const getPreventa = async (IdPreventa) => {
        try {
            setIsLoading(true);
            const response = await fetch(`/api/gestionPreventas/preventa/${IdPreventa}`);
            if (!response.ok) {
                throw new Error();
            }

            const preventa = await response.json();

            const [{IdCliente, IdTipoDocumentoSunat, Observaciones, GuiaRemision, OrdenCompra, Alias}] = preventa.respuesta;

            setPayload(prev => ({
                ...prev,
                IdPreventa,
                IdCliente,
                IdTipoDocumentoSunat,
                Observaciones,
                GuiaRemision,
                OrdenCompra,
                Alias
            }));

            await getDetallePreventa(IdPreventa)
        } catch (e) {
            console.error(e);
            notificarError("No se pudo cargar la preventa");
        } finally {
            setIsLoading(false);
        }
    };

    const getDetallePreventa = async (IdPreventa) => {
        try {
            const response = await fetch(`/api/gestionPreventas/detallepreventa/${IdPreventa}`);
            if (!response.ok) {
                throw new Error();
            }

            const { respuesta: detalles } = await response.json();

            const items = detalles.map(item => {
                const detail = {
                    ...item,
                    Cantidad: item.Cantidad,
                    Descuento: item.Descuento,
                    PrecioVenta: item.PrecioVenta,
                    PrecioEspecial: FindPrecioEspecial([], item),
                    PrecioFamiliar: FindPrecioFamiliar([], item),
                    PrecioCosto: GetPrecioCosto([], item),
                    PrecioMenor: FindPrecioMenor([], item),
                    precioMayor: getPrecioPorMayor([], item),
                    checked: 0,
                    oldPrecios: [item.PrecioVenta],
                    initialAfectGrat: item.IdAfectacionIgv,
                    oldCants: [1],
                    NombreProducto: item.descripcion,
                    Tributos: item.Tributos
                };

                detail.Total = calcTotal(detail);
                return detail;
            });

            updateState(items);
        } catch (e) {
            console.error(e);
            notificarError("No se pudo cargar el detalle de la preventa");
        }
    };

    const onCompleted = async () => {
        const pendingSaleId = sessionStorage.getItem('surtidores-pending-sale');

        if (pendingSaleId) {
            sessionStorage.removeItem('surtidores-pending-sale');
            fetch(`http://localhost:8080/api/v1/pendientes/${pendingSaleId}/estado`);
        }
    };

    if (isMobile) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
                <div className="alert alert-warning" role="alert">
                    <h4 className="alert-heading">Dispositivo no compatible</h4>
                    <p>Este modulo solo puede ser utilizado desde una computadora de escritorio.</p>
                </div>
            </div>
        );
    }
    /*bloqueo de cara en funcion al monto */

    return (
        <div className="container-fluid">
            <div className="row mt-2">
                <div className="col-md-7 px-1">
                    <div className="card abed__content-grifos">
                        <div className="card-body pb-2">
                            
                            <div className="preventa__cliente mt-1 mb-1" style={{ display: "block", 
                                opacity: panelBloqueado ? 0.5 : 1, 
                                position: "relative",
                                pointerEvents: panelBloqueado ? "none" : "auto" }}
                                >
                                  {panelBloqueado && (
                                        <div style={{
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        right: 0,
                                        bottom: 0,
                                        zIndex: 100,
                                        backgroundColor: 'rgba(255, 255, 255, 0.5)',
                                        cursor: 'not-allowed'
                                        }} />
                                    )}
                                <div className="row contenedor-muestra-clientes">
                                    <div className="col-12 col-md-8 mb-1" style={{ zIndex: "99" }}>
                                        <ClientPicker 
                                            defaultClient={payload.NroTipoDocumento} 
                                            onSelectClient={c => {
                                                setPayload(prev => ({
                                                    ...prev,
                                                    IdTipoDocumentoSunat: c.NroTipoDocumento.length === 11 ? FACTURA : prev.IdTipoDocumentoSunat,
                                                    _client: c
                                                }));
                                            }}
                                        />
                                    </div>
                                    <div className="abed__muestra_cliente d-none d-md-block">
                                        {payload._client ? `${payload._client.RazonSocial}` : "CLIENTE NO REGISTRADO"}
                                    </div>
                                    <div className="preventa__cliente2 d-md-none">
                                        {payload._client ? `${payload._client.RazonSocial}` : "CLIENTE NO REGISTRADO"}
                                    </div>
                                    <div className="col-12 col-md-3" style={{ zIndex: "99" }}>
                                        <InvoiceInfoInput 
                                            defaultText={queryParams.get("alias") ? queryParams.get("alias") : payload.Alias} 
                                            onChangeInfo={e => {
                                                setPayload(prev => ({
                                                    ...prev,
                                                    alias: e
                                                }));
                                            }} 
                                            placeholder={payload.conf?.useAliasAsOther ? "Placa (opcional)" : "Alias - Placa"}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div style={{ 
                                opacity: panelBloqueado ? 0.5 : 1, 
                                position: "relative",
                                pointerEvents: panelBloqueado ? "none" : "auto" 
                                }}>
                                {panelBloqueado && (
                                    <div style={{
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    bottom: 0,
                                    zIndex: 100,
                                    backgroundColor: 'rgba(255, 255, 255, 0.5)',
                                    cursor: 'not-allowed'
                                    }} />
                                )}
                                
                                    <DocTypeSelector
                                        hideDocKeys={payload.conf?.hideDocKeys}
                                        value={payload.IdTipoDocumentoSunat ? payload.IdTipoDocumentoSunat : BOLETA}
                                        onChange={d => {
                                        if (!panelBloqueado) {
                                            setPayload(prev => ({
                                            ...prev,
                                            _docType: d,
                                            IdTipoDocumentoSunat: d ? d.key : d,
                                            }));
                                        }
                                        }}
                                    />
                            </div>
                            <IslandSelector 
                                onSelectItem={onSelectItem}
                                isBlocked={!isClientValid()}
                            />
                        </div>
                        
                            <DetallesProductoGrifos
                                defaultBgInProductDetail={payload.conf?.defaultBgInProductDetail}
                                load={isLoading}
                                detalles={payload.detalles}
                                onSecretKeyPress={(e, item) => {
                                    if (e.ctrlKey && e.shiftKey && e.which === 51) {
                                        const items = [...payload.detalles];
                                        const i = items.indexOfObject(item, 'IdPresentacion');
                                        let foundedItem = items[i];
                                        const precio = foundedItem.precios.find(p => p.NombrePrecio.includes("Mayor"));
                                        foundedItem.Precio = precio ? precio.Precio : 0;
                                        foundedItem.PrecioVenta = precio ? precio.Precio : 0;
                                        foundedItem.ValorUnitario = precio ? precio.ValorUnitario : 0;
                                        foundedItem.Total = calcTotal({Cantidad: items[i].Cantidad, PrecioVenta: foundedItem.PrecioVenta});
                                        foundedItem.PrecioReferencial = parseFloat(foundedItem.PrecioVenta);
                                        updateState(items);
                                    }
                                }}
                                venderConListaPrecios={Number(payload.conf?.canSeePrices)}
                                incrementarPrecioProd={Boolean(payload.conf?.canIncrementProductPrice)}
                                PrecioChange={(e, item) => {
                                    const items = [...payload.detalles];
                                    const i = items.indexOfObject(item, 'IdPresentacion');
                                    let foundedItem = items[i];
                                    const precio = foundedItem.precios.find(p => p.NombrePrecio.includes(e.nativeEvent.target[e.nativeEvent.target.selectedIndex].text));
                                    foundedItem.Precio = precio ? precio.Precio : 0;
                                    foundedItem.PrecioVenta = precio ? precio.Precio : 0;
                                    foundedItem.ValorUnitario = precio ? precio.ValorUnitario : 0;
                                    foundedItem.Total = calcTotal({Cantidad: items[i].Cantidad, PrecioVenta: foundedItem.PrecioVenta});
                                    foundedItem.PrecioReferencial = parseFloat(foundedItem.PrecioVenta);
                                    updateState(items);
                                }}
                                InputCantidadDetalleChange={onChangeCantidad}
                                InputPrecioVentaChange={onPriceChange}
                                RestarCantidadDet={onSubstractQuantity}
                                AgregarCantidadDet={onAddQuantity}
                                RemoveProductoInList={onDeleteItem}
                                handleOpenModalDescuento={() => {}}
                                onBlurInputCantidad={() => {}}
                                descuentoPorCliente={0}
                                onBlurPrecioVenta={() => {}}
                                canUpdatePrice={payload.conf?.canUpdatePrice}
                                canUpdateTotal={payload.conf?.canUpdateTotal}
                                onChangeTotal={onChangeTotal}
                                onBlurTotal={() => {}}
                                hideQuantityButtons={false}
                                hideDeleteButton={false}
                                hideDiscountButton={false}
                                inline={false}
                            />
              
                    </div>
                </div>
                <div className="col-md-5 px-1">
                    <GrifosPagos 
                        IdPreventa={payload.IdPreventa} 
                        onCompleted={onCompleted}
                        isBlocked={panelPagosBloqueado}
                    />
                </div>
            </div>
        </div>
    );
};

export default Grifos;
